import '.l{display:flex;}.ssr-plugin'
import '.b2{align-items:stretch;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.d9{background:var(--palette-white);}.ssr-plugin'
import '.cd{flex-grow:1;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.bp{max-width:77.5rem;}.ssr-plugin'
import '.e9{justify-content:stretch;}.ssr-plugin'
import '.ea{position:sticky;}.ssr-plugin'
import '.cz{top:0;}.ssr-plugin'
import '.eb{z-index:10;}.ssr-plugin'
import '.ec{padding-block:1rem;}.ssr-plugin'
import '.ed{height:3rem;}.ssr-plugin'
import '.aw{justify-content:space-between;}.ssr-plugin'
import '.a7{flex-wrap:wrap;}.ssr-plugin'
import '.ee{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bn{margin-top:2rem;}.ssr-plugin'
import '.ef{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="l b2 a1 m d9"
      >
        <div className="cd l aa a1 m"
        >
          <div className="bp l m e9 ea cz eb d9"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ec ed l aw aa a7"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ee l m b2 bn ef bp"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
